import { Injectable, NgZone } from '@angular/core';
import { AwsService } from '../services/aws/aws.service';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoginService } from '../services/authentication/login.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class AuthGuardService {
  constructor(
    private readonly ngZone: NgZone,
    private readonly router: Router,
    private readonly loginService: LoginService,
    private readonly awsService: AwsService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.awsService.isLoggedIn().pipe(
      tap((loggedIn) => {
        this.ngZone.run(() => {
          if (!loggedIn) {
            this.router.navigate(['/account/login']);
          }
        });
      }),
    );
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
